import { useEffect, useRef, type MutableRefObject } from "react";

/**
 * React's "latest ref" pattern: returns a ref whose `.current` mirrors the
 * latest value of `value` after every render. Use this to keep an effect or
 * callback identity stable while still reading the freshest closure value.
 */
export function useLatestRef<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref;
}
